document.addEventListener('DOMContentLoaded', function() {
    let css = "";

    for (let categoryColor of document.getElementById("kanalc").dataset.colors.split(",")) {
        if (categoryColor.indexOf("#") !== -1) {
            let category = categoryColor.substring(0, categoryColor.length - 7);
            let color = categoryColor.substring(categoryColor.length - 7, categoryColor.length);
            let acolor = ".acolor-" + category;

            css += ".border-" + category + "{border-color:" + color + ";}" +
                acolor + " .menu .active>a, " +
                acolor + " a:not(.btn), " +
                acolor + " .icon-search, " +
                ".archivecolor-" + category + " .more-link{color:" + color + ";}" +

                acolor + " a:not(.btn):hover, " +
                acolor + " a:not(.btn):focus, " +
                acolor + " .menu .active>a:hover, " +
                acolor + " .menu .active>a:focus, " +
                acolor + " .icon-search:hover, " +
                acolor + " .icon-search:focus, " +
                ".archivecolor-" + category + " .more-link:hover, " +
                ".archivecolor-" + category + " .more-link:focus{color:rgb(" + _0x2rgb(color, 35) + ");}" +

                acolor + " .btn{background-color:" + color + ";}" +
                acolor + " .btn:hover, " + acolor + " .btn:focus{background-color:rgb(" + _0x2rgb(color, 25) + ");}" +

                ".bgcolor-" + category + "{background-color:rgba(" + _0x2rgb(color) + ",0.45);}" +
                ".diagonal-" + category + "{background:url(\"data:image/svg+xml," + _makeSVG(color) + "\") 0px 0px/15px;}" +
                ".bg-" + category + "{background:url(\"data:image/svg+xml," + _makeSVG(color) + "\") 0px 0px/8px;}";
        }
    }

    document.getElementById("kac-color-style").innerHTML = css;

    function _0x2rgb(str, plus = 0) {
        const toDec = ( (str, pos, plus) => {
            let val = parseInt(str.substr(pos, 2), 16) + plus;
            return (val > 255 ? 255 : val);
        } );

        return toDec(str, 1, plus) + "," +
               toDec(str, 3, plus) + "," +
               toDec(str, 5, plus);
    }

    function _makeSVG(color) {
        return "<svg xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' " +
            "xmlns='http://www.w3.org/2000/svg' height='20' width='20' " +
            "xmlns:cc='http://creativecommons.org/ns%23' " +
            "xmlns:dc='http://purl.org/dc/elements/1.1/' viewBox='0 0 20 20'>" +
            "<g fill-rule='evenodd' transform='translate(0 -1032.4)' stroke-width='0' " +
            "fill='%23" + color.substring(1, color.length) + "'>" + // %23 is HTML encoding for # and strictly necessary.
                "<path d='m0.000005 1034.9 2.5-2.5h-2.5z'/>" +
                "<path d='m0.000005 1039.9 7.5-7.5h5l-12.5 12.5z'/>" +
                "<path d='m0.000005 1049.9 17.5-17.5h2.5v2.5l-17.5 17.5h-2.5z'/>" +
                "<path d='m7.5 1052.4 12.5-12.5v5l-7.5 7.5z'/>" +
                "<path d='m17.5 1052.4 2.5-2.5v2.5z'/>" +
            "</g></svg>";
    }
});
